// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19n8b","fullView":"styles_fullView__gnhWE"};